import React, { useState } from "react";
import {Switch, Route, useLocation } from 'react-router-dom';
import baseUrl from "config/baseUrl";
import Layout  from "shared/container/LayoutAdmin";
import AdminUserList from "./Routes/AdminUserList";
import AdminUserDetail from "./Routes/AdminUserDetail";
import AdminUserCreate from "./Routes/AdminUserCreate";

const axios = require("axios").default;


const AdminUser = (props) => {
  const { match } = props;
    const routes = [
      {
        path: `${match.path}`,
        component: AdminUserList,
        name: "AdminUser List",
        exact: true,
      },
      {
        path: `${match.path}/detail/:id`,
        component: AdminUserDetail,
        name: "AdminUser Detail",
        exact: true,
      },
      {
        path: `${match.path}/create`,
        component: AdminUserCreate,
        name: "AdminUser Create",
        exact: true,
      }
    ]
    .map((route, index) => (
      <Route exact={route.exact} key={index} path={route.path} component={route.component} />
    ));
  return (
    <>
      <Layout>
          <Switch>
            {routes}
          </Switch>
      </Layout>
    </>
  );
};

export default AdminUser;
